import { InjectionToken, ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PlatformModule } from "@angular/cdk/platform";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { YoumAngularLibModule } from "@youm-front/youm-angular-lib";
import { AppDoubleMatSlideToggleModule } from "../modules/double-mat-slide-toggle/double-mat-slide-toggle.module";
import Components from "./components";
import Dialogs from "./dialogs";

export interface IEnvironment {
  domain: string;
  serverURL: string;
}

export const Environment = new InjectionToken<IEnvironment>("Environment");

@NgModule({
  declarations: [...Dialogs, ...Components],
  imports: [
    CommonModule,
    PlatformModule,
    MatTooltipModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSlideToggleModule,
    YoumAngularLibModule,
    AppDoubleMatSlideToggleModule
  ],
  exports: [...Dialogs, ...Components]
})
export class CoreModule {
  public static forRoot(params: {
    environment: IEnvironment;
  }): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        {
          provide: Environment,
          useValue: params.environment
        }
      ]
    };
  }
}
